import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getRiskFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t(`risks.fields.title`),
      columnHeader: t(`risks.columns.risk_name`),
      allowAsConditionSource: true,
    },
    Description: {
      fieldId: 'Description',
      formLabel: t(`risks.fields.description`),
      columnHeader: t(`risks.columns.risk_description`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    Tier: {
      fieldId: 'Tier',
      formLabel: t(`risks.fields.tier`),
      columnHeader: t(`risks.columns.risk_tier`),
      allowAsConditionSource: true,
      displayType: { displayType: 'commonLookup', i18nKey: 'tiers' },
    },
    ParentRiskId: {
      fieldId: 'ParentRiskId',
      formLabel: t(`risks.fields.parent`),
      columnHeader: t(`risks.columns.parent_risk`),
      // A risk can only have a parent when it sits below the top tier, so the
      // Parent field is shown only for Tier 2/3. This mirrors the hardcoded
      // `<ConditionalField condition={tier > 1}>` that drives the flag-off form;
      // declaring it here makes the configure-form editor preview (and flag-on
      // runtime) gate Parent on Tier too. Read-only: the dependency is
      // structural and admins must not be able to remove it.
      defaultConditions: {
        readOnly: true,
        rules: [{ ifField: 'Tier', values: ['2', '3'] }],
      },
    },
    Treatment: {
      fieldId: 'Treatment',
      formLabel: t(`risks.fields.treatment`),
      columnHeader: t(`risks.columns.risk_treatment`),
      allowAsConditionSource: true,
      allowTargetConditions: true,
      displayType: { displayType: 'commonLookup', i18nKey: 'treatments' },
    },
    Status: {
      fieldId: 'Status',
      formLabel: t(`risks.fields.status`),
      columnHeader: t(`risks.columns.risk_status`),
      allowAsConditionSource: true,
      allowTargetConditions: true,
      displayType: {
        displayType: 'commonLookup',
        i18nKey: 'statuses',
      },
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: t(`fields.Owner`),
      columnHeader: t(`columns.owners`),
      allowAsConditionSource: true,
      displayType: {
        displayType: 'users',
        multiple: true,
      },
    },
    Contributors: {
      fieldId: 'Contributors',
      formLabel: t(`fields.Contributor`),
      columnHeader: t(`columns.contributors`),
      allowAsConditionSource: true,
      allowTargetConditions: true,
      displayType: {
        displayType: 'users',
        multiple: true,
      },
    },
    Viewers: {
      fieldId: 'Viewers',
      formLabel: t(`fields.Viewer`),
      columnHeader: t(`columns.viewers`),
      allowAsConditionSource: true,
      allowTargetConditions: true,
      displayType: {
        displayType: 'users',
        multiple: true,
      },
    },
    tags: {
      fieldId: 'tags',
      formLabel: t(`fields.Tags`),
      columnHeader: t(`columns.tags`),
      allowTargetConditions: true,
      allowAsConditionSource: true,
      displayType: {
        displayType: 'tags',
      },
    },
    departments: {
      fieldId: 'departments',
      formLabel: t(`fields.Departments`),
      columnHeader: t(`columns.departments`),
      allowTargetConditions: true,
      allowAsConditionSource: true,
      displayType: {
        displayType: 'departments',
      },
    },
  } as const satisfies FormConfig;
};
